<template>
  <div class="gd-totals">
    <div class="gd-totals-head">Totais desta guia</div>
    <div class="gd-totals-row main">
      Convênio
      <span class="loading" v-if="loading"></span>
      <fa-icon class="text-error" :icon="['fal', 'lock']" v-else-if="hideInsuranceValue"/>
      <b v-else>{{ totals.insurance | currency }}</b>
    </div>
    <div class="gd-totals-row" v-if="!single">
      Itens na guia
      <b>{{ totals.selected }}<template v-if="totals.count !== totals.selected">
        de {{ totals.count }}</template></b>
    </div>
    <div class="gd-totals-row" v-if="!single">
      Procedimentos · Outras despesas
      <b>{{ totals.procedures }} · {{ totals.others }}</b>
    </div>
    <div class="gd-totals-row" v-if="informed !== null">
      Faturado no lote
      <fa-icon class="text-error" :icon="['fal', 'lock']" v-if="hideInsuranceValue"/>
      <b v-else>{{ informed | currency }}</b>
    </div>
    <div class="gd-totals-row courtesy" v-if="!readonly">
      <label class="form-switch">
        <input type="checkbox" :checked="courtesy"
               @change="$emit('update:courtesy', $event.target.checked)">
        <i class="form-icon"></i>Cortesia (zera convênio e repasse)
      </label>
    </div>
    <div class="gd-totals-row courtesy" v-else-if="courtesy">
      <span class="gd-pill gd-pill-pending"><fa-icon :icon="['fal', 'gift']"/>Cortesia</span>
    </div>
    <div class="gd-totals-note" v-if="courtesy">
      Cortesia: nada será faturado ao convênio e não há repasse para o profissional.
    </div>
  </div>
</template>

<script>
export default {
  props: {
    totals: {
      type: Object,
      default: () => ({
        insurance: 0, particular: 0, count: 0, selected: 0, procedures: 0, others: 0,
      }),
    },
    courtesy: {
      type: Boolean,
      default: false,
    },
    single: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    informed: {
      type: Number,
      default: null,
    },
    hideInsuranceValue: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
